import { Box, Card } from '@mui/material';
import { Route, Switch, useRouteMatch } from 'react-router';
import OwnersDirectory from './components/OwnersDirectory';
import { OwnerDetailsWizard } from './components/OwnerDetailsWizard';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  gridContainer: {
    background: '#FFFFFF',
    borderRadius: '24px',
  },
});

/**
 * Main placeholder page for Owners in the PMUI
 * @param props
 * @returns
 */
export default function Owners() {
  let { path } = useRouteMatch();
  const classes = useStyles();

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Card
        sx={{
          mt: 3.5,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc( 100vh - 144px )',
        }}
        className={classes.gridContainer}
        style={{ position: 'relative' }}
      >
        <Switch>
          <Route exact path={path}>
            <OwnersDirectory />
          </Route>
          <Route path={`${path}/:id`}>
            <OwnerDetailsWizard />
          </Route>
        </Switch>
      </Card>
    </Box>
  );
}
